import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import FooterCopyright from "./sub-components/FooterCopyright";
import FooterNewsletter from "./sub-components/FooterNewsletter";
import { multilanguage } from "redux-multilanguage";
import createDOMPurify from 'dompurify'
import { JSDOM } from 'jsdom'
import {
    Modal
} from "react-bootstrap";
import {
    globalURL,
    fetchApiHeaders
} from "../../constants";

const FooterOne = ({
    strings,
    currentLanguageCode,
    backgroundColorClass,
    spaceTopClass,
    spaceBottomClass,
    spaceLeftClass,
    spaceRightClass,
    containerClass,
    extraFooterClass,
    sideMenu
}) => {
    const [scroll, setScroll] = useState(0);
    const [top, setTop] = useState(0);

    const [show, setShow] = useState(false);
    const [data, setData] = useState(null);

    const handleClose = () => setShow(false);

    const handleShow = async (type) => {
        setData(null);
        setShow(true);
        let content = await fetch(globalURL + "/template/getFileContent", {
            method: 'POST',
            headers: fetchApiHeaders.POST,
            body: JSON.stringify({
                type: type
            })
        });
        let contentJSON = await content.json();
        if (contentJSON.success) {
            setData(contentJSON.data);
        }
    };

    const _window = (new JSDOM('')).window
    const DOMPurify = createDOMPurify(_window);

    useEffect(() => {
        setTop(100);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        animateScroll.scrollToTop();
    };

    const handleScroll = () => {
        setScroll(window.scrollY);
    };

    return (
        <footer
            className={`footer-area ${backgroundColorClass ? backgroundColorClass : ""
                } ${spaceTopClass ? spaceTopClass : ""} ${spaceBottomClass ? spaceBottomClass : ""
                } ${extraFooterClass ? extraFooterClass : ""} ${spaceLeftClass ? spaceLeftClass : ""
                } ${spaceRightClass ? spaceRightClass : ""}`}
        >
            <Modal animation={false} style={{ background: "gray", fontFamily: "Poppins, Helvetica, sans-serif", fontSize: "smaller" }} show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{data !== null ? data.title : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {<div style={{ backgroundColor: "transparent" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data !== null ? data.content : "") }} />}
                </Modal.Body>
            </Modal>

            <div className={`${containerClass ? containerClass : "container"}`}>
                <div className="row">
                    <div
                        className={`${sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-3"
                            }`}
                    >
                        {/* footer copyright */}
                        <FooterCopyright
                            footerLogo="/assets/img/logo/iola_logo_w.svg"
                            spaceBottomClass="mb-30"
                        />
                    </div>
                    <div
                        className={`${sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-2"
                            }`}
                    >
                        <div className="footer-widget mb-30">
                            <div className="footer-title">
                                <h3>{strings['footer']['aboutUs']['title']}</h3>
                            </div>
                            <div className="footer-list">
                                <ul>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/about"}>
                                            {strings['footer']['aboutUs']['links']['aboutUs']}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={process.env.PUBLIC_URL + "/contact"}>
                                            {strings['footer']['aboutUs']['links']['contact']}
                                        </Link>
                                    </li>
                                    {/* <li>
                    <Link>
                      {strings['footer']['aboutUs']['links']['orderTracking']}
                    </Link>
                  </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-3"
                            }`}
                    >
                        <div
                            className={`${sideMenu
                                ? "footer-widget mb-30 ml-95"
                                : "footer-widget mb-30"
                                }`}
                        >
                            <div className="footer-title">
                                <h3>{strings['footer']['usefulLinks']['title']}</h3>
                            </div>
                            <div className="footer-list">
                                <ul>
                                    <li>
                                        <a onClick={() => handleShow("cancellationAndReturn")} href="#" rel="noopener noreferrer">
                                            {strings['footer']['usefulLinks']['links']['returns']}
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => handleShow("privacyAndSecurity")} href="#">
                                            {strings['footer']['usefulLinks']['links']['privacyAndSecurity']}
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => handleShow("aggrement")} href="#">
                                            {strings['footer']['usefulLinks']['links']['salesAggrement']}
                                        </a>
                                    </li>
                                    {/* <li>
                    <Link>
                      {strings['footer']['usefulLinks']['links']['faqs']}
                    </Link>
                  </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${sideMenu ? "col-xl-3 col-sm-4" : "col-lg-2 col-sm-2"
                            }`}
                    >
                        <div
                            className={`${sideMenu
                                ? "footer-widget mb-30 ml-145"
                                : "footer-widget mb-30"
                                }`}
                        >
                            <div className="footer-title">
                                <h3>{strings['footer']['followUs']['title']}</h3>
                            </div>
                            <div className="footer-list">
                                <ul>
                                    <li>
                                        <a
                                            href="https://www.instagram.com/iolafashionofficial/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Instagram
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.facebook.com/Iolafashionofficial-109996471230020"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Facebook
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`${sideMenu ? "col-xl-3 col-sm-8" : "col-lg-4 col-sm-2"
                            }`}
                    >
                        {/* footer newsletter */}
                        <FooterNewsletter
                            spaceBottomClass="mb-30"

                            sideMenu={sideMenu}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">

                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center" }} className="col-md-6">
                        <img alt="IOLA FASHION iola fashion iolafashion" style={{ height: 25, marginRight: 5 }} src={`/assets/img/icon-img/iyzico_${currentLanguageCode}.svg`} />
                        <img alt="IOLA FASHION iola fashion iolafashion" style={{ height: 25, marginRight: 5 }} src="/assets/img/icon-img/maestro.svg" />
                        <img alt="IOLA FASHION iola fashion iolafashion" style={{ height: 25, marginRight: 5 }} src="/assets/img/icon-img/amex.svg" />
                        <img alt="IOLA FASHION iola fashion iolafashion" style={{ height: 25, marginRight: 5 }} src="/assets/img/icon-img/mastercard.svg" />
                        <img alt="IOLA FASHION iola fashion iolafashion" style={{ height: 25, marginRight: 5 }} src="/assets/img/icon-img/visa.svg" />
                        <div style={{ backgroundColor: "#ffffff", display: "flex", justifyContent:"center", alignItems:"center", borderRadius:3}}><img alt="IOLA FASHION iola fashion iolafashion" style={{ height: 15, margin:5 }} src="/assets/img/icon-img/troy.svg" /></div>
                    </div>
                </div>
            </div>
            <button
                className={`scroll-top ${scroll > top ? "show" : ""}`}
                onClick={() => scrollToTop()}
            >
                <i className="fa fa-angle-double-up"></i>
            </button>
        </footer>
    );
};

FooterOne.propTypes = {
    backgroundColorClass: PropTypes.string,
    containerClass: PropTypes.string,
    extraFooterClass: PropTypes.string,
    sideMenu: PropTypes.bool,
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string,
    spaceLeftClass: PropTypes.string,
    spaceRightClass: PropTypes.string
};

export default multilanguage(FooterOne);
